import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsAppWelcomeCouponBannerEnabled = () => {
  return useIsFeatureActive('enable_app_welcome_coupon_banner').isActive;
};
